// extracted by mini-css-extract-plugin
export default {"background":"home_background__yXDLV","container":"home_container__yWxgv","search-area":"home_search-area__nyAY-","zaqtiv":"home_zaqtiv__smUEC","searchbar":"home_searchbar__8Se-o"};